import { JSXElement, mergeProps } from 'solid-js';
import { ark, HTMLArkProps } from '@ark-ui/solid';

type TrProps = HTMLArkProps<'tbody'>;

export default function Tr(props: TrProps): JSXElement {
  const merged = mergeProps({}, props);

  return <ark.tbody {...merged}>{merged.children}</ark.tbody>;
}
